import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import stylesDocCss from './documents.scss'
//import styles from './packageClientEmailChange.scss'
import Modal from 'react-modal'
import i18n from 'lib/i18n'
import nesProp from 'nested-property'
import { customModalStyles } from './documentsHelpers'
import { updateDSDocumentPackage, executeFullDSDocumentWizardOnServer, getDsDocsAndPackages, updateDSStakeholder, hideLoader, showLoader, getOneDsPackageById } from 'state/actions'
import { isAnEmail } from 'lib/validator'
import { fetchSrcValuesFromHtml } from '../emailSender/helpers'
import cs from 'classnames'
import { setNotification, getDSStakeholders } from '../../state/actions'
import phoneCodes from '../phoneCountryCodesSelect.json'
import * as c from 'state/constants'
import EmailButton from '../emailSender/emailButton'

// init translations
const _ = i18n('dsdocuments')

/**
 * Connect module to store
 */
@connect(
    (state) => ({
        openedPackage: state.DSDocuments.openedPackage,
        // dsdocuments: state.DSDocuments.items,
    })
)
/**
 * ClientContactInfoChangerModalForPackage class used to change the client email-address and resend the invitation email.
 */
export default class ClientContactInfoChangerModalForPackage extends Component {
    static propTypes = {
        dsPackage: PropTypes.object,
        triggerToOpen: PropTypes.bool,
        callBackOnClose: PropTypes.func,
        isEditableThePackage: PropTypes.bool,
        stakeholder: PropTypes.object,
        editClientEmail: PropTypes.bool,
        editClientPhoneNumber: PropTypes.bool,
        moduleKeyToSet: PropTypes.string,
        emailerModuleOptions: PropTypes.object,
        onSentEmailer: PropTypes.func,
        onInitEmailer: PropTypes.func,
    }

    /**
     * Module constructor
     * @param {*} props
     */
    constructor(props) {
        super(props)
        // initilaize from incoming props
        let resendToAddress = nesProp.get(props, "dsPackage.clientEmailAddress")
        let originalPhoneNumber = nesProp.get(props, 'stakeholder.phoneNumber')

        this.state = {
            clientEmailChangePopupIsOpen: false,
            resendToAddress: resendToAddress,
            resendingButtonDisabled: false,
            resendToAddressValid: resendToAddress && isAnEmail(resendToAddress),
            resendToAddressTouched: false,
            changeSent: false,
            newPhoneNumber: originalPhoneNumber,
            newPhoneNumberValue: false,
            newPhoneNumberTouched: false,
            dsPackage: {},
            step: 1,
            emailerModuleOptions: JSON.parse(JSON.stringify(props.emailerModuleOptions)),
            invitationSent: false
        }
    }

    /**
     * check if there is package data and the right package is opened
     */
    async componentWillMount() {
        const { dispatch, openedPackage, dsPackage } = this.props
        try {
            if (!dsPackage || !dsPackage._id || dsPackage._id.toString() !== openedPackage) {
                const getPackageReq = await dispatch(getOneDsPackageById(openedPackage))
                this.setState({dsPackage: getPackageReq})
            } else {
                this.setState({dsPackage})

            }
        } catch (error) {
            console.warn(error)
        }
    }

    /**
     * This will render the modal content of status explainer in case of error for email editing.
     */
    clientEmailChangePopup() {
        const { resendToAddress, resendingButtonDisabled, resendToAddressValid,
            resendToAddressTouched, dsPackage, changeSent } = this.state
        const { stakeholder } = this.props
        const isDifferByOriginal = (stakeholder && stakeholder.email) ? (resendToAddress !== stakeholder.email) : (resendToAddress !== nesProp.get(dsPackage, "clientEmailAddress"))

        return (
            <div className={stylesDocCss.documentsModalContent}>
                <span className={stylesDocCss.title}>{_('clientEmailChangeModalTitle')}</span>
                <span className={stylesDocCss.message}>
                    <div className={stylesDocCss.resendModalContainer}>
                        <div>{_('clientEmailChangeModalDescription')}</div>
                        <div className={stylesDocCss.formInputContainer}>
                            <label className={stylesDocCss.formLabel}>{_('typeANewEmailAddressToSend')}:* </label>
                            <input
                                className={cs(stylesDocCss.formInput, stylesDocCss.long)}
                                type="text"
                                value={resendToAddress}
                                onChange={(e) => {
                                    this.changeResendEmailToAddress(e.target.value)
                                }}
                                onBlur={() => {
                                    this.setState({ resendToAddressTouched: true })
                                }}
                            />
                        </div>
                        {!changeSent && !resendToAddressValid && resendToAddressTouched && <div>
                            <div className={stylesDocCss.errorMessage}>
                                {_('emailAddressIsRequired')}
                            </div>
                        </div>}
                        {!changeSent && !isDifferByOriginal && resendToAddressTouched && <div>
                            <div className={stylesDocCss.errorMessage}>
                                {_('emailAddressMustBeDifferent')}
                            </div>
                        </div>}
                    </div>
                </span>
                <div className={stylesDocCss.documentsModalButtons}>
                    <div
                        onClick={() => {
                            // just reset triggers and states and close modal
                            this.closeModal()
                        }}
                        className={stylesDocCss.cancel}
                    >
                        {_("cancel")}
                    </div>
                    <input
                        onClick={() => {
                            this.setState({ changeSent: true })
                            // update records, restart the hole Digi-Sign flow, send mail again
                            this.onClientEmailChange()
                        }}
                        type="button"
                        className={stylesDocCss.greenButton + ((resendingButtonDisabled || !resendToAddressValid) ? " disabled" : " enabled")}
                        value={_("clientEmailChange")}
                        disabled={resendingButtonDisabled || !resendToAddressValid || !isDifferByOriginal}
                    />
                </div>
            </div>
        )
    }

    /**
     * This will render the modal content of status explainer in case of error for phone number editing.
     */
    clientPhoneNumberChangePopup() {
        const { newPhoneNumber, newPhoneNumberValid, resendingButtonDisabled, newPhoneNumberTouched, changeSent } = this.state
        const { stakeholder } = this.props
        const isDifferByOriginal = (stakeholder && stakeholder.phoneNumber) ? (newPhoneNumber !== stakeholder.phoneNumber) : false

        return (
            <div className={stylesDocCss.documentsModalContent}>
                <span className={stylesDocCss.title}>{_('clientPhoneNumberChangeModalTitle')}</span>
                <span className={stylesDocCss.message}>
                    <div className={stylesDocCss.resendModalContainer}>
                        <div>{_('clientPhoneNumberChangeModalDescription')}</div>
                        <div className={stylesDocCss.formInputContainer}>
                            <label className={stylesDocCss.formLabel}>{_('typeANewPhoneNumber')}:* </label>
                            <input
                                className={cs(stylesDocCss.formInput, stylesDocCss.long)}
                                type="text"
                                value={newPhoneNumber}
                                onChange={(e) => {
                                    this.changePhoneNumber(e.target.value)
                                }}
                                onBlur={() => {
                                    this.setState({ newPhoneNumberTouched: true })
                                }}
                            />
                        </div>
                        {(!newPhoneNumber || newPhoneNumber.length === 0) && newPhoneNumberTouched && <div>
                            <div className={stylesDocCss.errorMessage}>
                                {_('phoneNumberIsRequired')}
                            </div>
                        </div>}
                        {(newPhoneNumber && newPhoneNumber.length > 0) && !changeSent && !newPhoneNumberValid && newPhoneNumberTouched && <div>
                            <div className={stylesDocCss.errorMessage}>
                                {_('phoneNumberIsInvalid')}
                            </div>
                        </div>}
                        {!changeSent && !isDifferByOriginal && newPhoneNumberTouched && <div>
                            <div className={stylesDocCss.errorMessage}>
                                {_('phoneNumberMustBeDifferent')}
                            </div>
                        </div>}
                    </div>
                </span>
                <div className={stylesDocCss.documentsModalButtons}>
                    <div
                        onClick={() => {
                            // just reset triggers and states and close modal
                            this.closeModal()
                        }}
                        className={stylesDocCss.cancel}
                    >
                        {_("cancel")}
                    </div>
                    <input
                        onClick={() => {
                            this.setState({ changeSent: true })
                            // update records, restart the hole Digi-Sign flow, send mail again
                            this.onClientEmailChange()
                        }}
                        type="button"
                        className={stylesDocCss.greenButton + ((resendingButtonDisabled || !newPhoneNumberValid) ? " disabled" : " enabled")}
                        value={_("clientPhoneNumberChange")}
                        disabled={resendingButtonDisabled || !newPhoneNumberValid || !isDifferByOriginal}
                    />
                </div>
            </div>
        )
    }

    /**
     * Change the email-address in state, validate also.
     * @param {*} value
     */
    changeResendEmailToAddress(value) {
        // check validity
        let valid = true

        if (!value || !isAnEmail(value)) {
            valid = false
        }

        this.setState({
            resendToAddress: value,
            resendToAddressValid: valid
        })
    }

    /**
    * Change the phone number in state, validate also.
    * @param {*} value
    */
    changePhoneNumber(phoneNumber) {

        //check if phone number starts with "00" or "+" than normalize it if necessary
        if (phoneNumber.trim()[0] === "+") {
            phoneNumber = "00" + phoneNumber.substring(1)
        }

        //check if is a number
        const isNumber = /^\d+$/.test(phoneNumber)

        //the max length for a country code in our codes list is 6
        let maxPhoneCodeLength = 6
        const countryCode = phoneNumber.slice(0, maxPhoneCodeLength)
        let countryCodeIsValid = false
        for (let code of phoneCodes) {
            if (countryCode.startsWith(code.phoneCode)) {
                countryCodeIsValid = code.phoneCode
            }
        }
        let slicedNumber = phoneNumber.slice(countryCodeIsValid.length)
        phoneNumber = `+${phoneNumber.substring(2)}`
        this.setState({
            newPhoneNumber: phoneNumber,
            newPhoneNumberValid: (isNumber && countryCodeIsValid && slicedNumber && slicedNumber.length === 9)
        })

    }



    /**
     * Any case of modal close must call this function to reset states and call the callback function
     */
    closeModal() {
        const { callBackOnClose } = this.props
        const { resendToAddress } = this.state

        this.setState({ resendToAddressTouched: false,
            clientEmailChangePopupIsOpen: false,
            resendingButtonDisabled: false,
            resendToAddress: "",
            changeSent: false,
            newPhoneNumber: "",
            newPhoneNumberTouched: false,
            step: 1
        })

        //anyway must called to reset external trigger also for modal opening
        callBackOnClose()
    }

    /**
     * This function triggered by modal confirmation button (ok button)
     */
    async onClientEmailChange() {
        let { resendToAddress, dsPackage, newPhoneNumber, emailerModuleOptions } = this.state
        const { dispatch, stakeholder, isEditableThePackage, editClientEmail, editClientPhoneNumber } = this.props
        let userProcess

        this.setState({ resendingButtonDisabled: true })

        // no modification no update (optimisation)
        let isDifferByOriginal
        if (editClientEmail) {
            isDifferByOriginal = (stakeholder && stakeholder.email) ? (resendToAddress !== stakeholder.email) : (resendToAddress !== nesProp.get(dsPackage, "clientEmailAddress"))
            userProcess = c.DSDOCUMENT_EMAIL_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS
        } else if (editClientPhoneNumber) {
            isDifferByOriginal = (stakeholder && stakeholder.phoneNumber) ? (newPhoneNumber !== stakeholder.email) : false
            userProcess = c.DSDOCUMENT_PHONE_NUMBER_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS
        }

        if (!isDifferByOriginal) {
            this.closeModal()
            return
        }

        try {
            dispatch(showLoader())
            await this.updateSigner()

            // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // in case of the package is editable, that is mean not set the pending status for connective, so we don't want
            // to finish the process.
            if (!isEditableThePackage) {
                let noLoader = true // show/hide spiner
                await dispatch(executeFullDSDocumentWizardOnServer(nesProp.get(dsPackage, "_id"), userProcess, noLoader))
                dsPackage = await dispatch(getOneDsPackageById(nesProp.get(dsPackage, "_id")))

                // update
                for (let j=0; j < dsPackage.dsStakeholders.length; j++) {
                    if (stakeholder._id === dsPackage.dsStakeholders[j]._id) {
                        stakeholder.email = dsPackage.dsStakeholders[j].email
                    }
                }

                for (let j=0; j < emailerModuleOptions.stakeholders.length; j++) {
                    if (stakeholder._id === emailerModuleOptions.stakeholders[j]._id) {
                        emailerModuleOptions.stakeholders[j].email = stakeholder.email
                    }
                }

                for (let j=0; j < emailerModuleOptions.clientEmails.length; j++) {
                    if (stakeholder._id === emailerModuleOptions.clientEmails[j].referenceId) {
                        emailerModuleOptions.clientEmails[j].value = stakeholder.email
                    }
                }
            }

            // dispatch(setNotification(_("success"), 'info'))
            dispatch(hideLoader())
        } catch (err) {
            // TODO show an advanced error for the user if the process fail somewhere
            dispatch(hideLoader())
            console.error(err);
            dispatch(setNotification(JSON.stringify(err), 'error'))
            this.closeModal()
        }

        this.setState({dsPackage, step: 2, emailerModuleOptions})
        return
    }

    async updateSigner() {
        const { resendToAddress, dsPackage, newPhoneNumber } = this.state
        const { dispatch, stakeholder, editClientPhoneNumber, editClientEmail } = this.props

        if (editClientEmail) {
            // update stakeholder email if the package preceds the stakeholder functionality we will use old implementation
            if (stakeholder) {
                return dispatch(updateDSStakeholder({
                    stakeholderId: nesProp.get(stakeholder, "_id"),
                    email: resendToAddress
                }))
            }

            // update client email in package, this automatically will refresh the list of documents also
            // this logic only apply for old packages before introduction of two signers
            return dispatch(updateDSDocumentPackage({
                _id: nesProp.get(dsPackage, "_id"),
                clientEmailAddress: resendToAddress
            }))
        } else if (editClientPhoneNumber) {
            return dispatch(updateDSStakeholder({
                stakeholderId: nesProp.get(stakeholder, "_id"),
                phoneNumber: newPhoneNumber
            }))
        }

    }

    componentWillReceiveProps(nextProps) {
        const { triggerToOpen, opened } = this.props
        const { dsPackage } = this.state

        const stakeholder = nesProp.get(nextProps, 'stakeholder')

        let resendToAddress = nesProp.get(nextProps, "dsPackage.clientEmailAddress")
        let newPhoneNumber
        if (stakeholder) {
            resendToAddress = stakeholder.email
            newPhoneNumber = stakeholder.phoneNumber
        }

        // take action only when props set true
        if (nextProps.triggerToOpen !== triggerToOpen) {
            if (nextProps.triggerToOpen) {
                this.setState({
                    resendToAddress, newPhoneNumber,
                    clientEmailChangePopupIsOpen: true
                })
            }
        }

        // check if document content modified
        let newPackage = nesProp.get(nextProps, "dsPackage")
        if (newPackage) {

            if (newPackage._id !== dsPackage._id) {
                this.setState({ dsPackage: newPackage })
            }
        }

        return true
    }

    renderCustomizeInvitationEmails() {
        const { resendToAddress, resendingButtonDisabled, resendToAddressValid,
            resendToAddressTouched, changeSent, emailerModuleOptions, invitationSent } = this.state
        const { stakeholder, moduleKeyToSet, dispatch } = this.props
        const isDifferByOriginal = (stakeholder && stakeholder.email) ? (resendToAddress !== stakeholder.email) : (resendToAddress !== nesProp.get(dsPackage, "clientEmailAddress"))
        let {dsPackage} = this.props
        let that = this

        let wasPending = false
        dsPackage.statusHistory.forEach((oneStatus) => {
            if (oneStatus.status === c.DS_PACKAGE_STATUS_PENDING) {
                wasPending = true
            }
        })

        return (
            <div className={stylesDocCss.documentsModalContent}>
                <span className={stylesDocCss.title}>{_('clientEmailChangeModalTitle')}</span>
                <span className={stylesDocCss.message}>
                    <div className={stylesDocCss.resendModalContainer}>
                        <div>{!invitationSent ? _('clientEmailChangeModalInvitationDescription') : _('clientEmailChangeModalDoneDescription')}</div>
                    </div>
                </span>
                <div className={stylesDocCss.documentsModalButtons}>
                    <div
                        onClick={() => {
                            // just reset triggers and states and close modal
                            this.closeModal()
                        }}
                        className={stylesDocCss.cancel}
                    >
                        {_("cancel")}
                    </div>

                    {!invitationSent && dsPackage.dsStakeholders && wasPending &&
                    <EmailButton
                        customButtonLabel={_('customizeInvitationEmail')}
                        isWhiteIcon={true}
                        modalId={c.EMAILER_MODAL_ID_EDIT_EMAIL_OF_PACAKGE}
                        hideCC={true}
                        multiLanguage={true}
                        serialSending={true}
                        isCreatable={false}
                        forceIsMulti={true}
                        key={"customizeInvitationRenderEmailSenderButtonFromEmailChangerKey"}
                        onInit={() => {
                            this.props.onInitEmailer()
                        }}
                        onSentLate={async (responses) => {
                            dsPackage = await that.props.onSentEmailer(responses, dsPackage, dsPackage.dsStakeholders)
                            that.setState({invitationSent: true})
                        }}
                        moduleKeyToSet={moduleKeyToSet}
                        moduleOptions={emailerModuleOptions}
                        getDSStakeholders={async (stakeholderIdArray) => (await dispatch(getDSStakeholders(stakeholderIdArray)))}
                        customClassName={stylesDocCss.greenButton + " enabled"}
                    /> ||
                    <input
                        onClick={() => {
                            this.closeModal()
                        }}
                        type="button"
                        className={stylesDocCss.greenButton + " enabled"}
                        value={_("ok")}
                    />}
                </div>
            </div>
        )
    }

    render() {
        const { editClientEmail, editClientPhoneNumber } = this.props
        const { clientEmailChangePopupIsOpen, step } = this.state

        return (<div>
            <Modal
                isOpen={Boolean(clientEmailChangePopupIsOpen)}
                contentLabel={''}
                style={customModalStyles}
            >
                {step == 1 && editClientEmail && this.clientEmailChangePopup()}
                {step == 1 && editClientPhoneNumber && this.clientPhoneNumberChangePopup()}
                {step == 2 && this.renderCustomizeInvitationEmails()}
            </Modal>
        </div>)
    }

}



// WEBPACK FOOTER //
// ./components/DSDocuments/clientContactInfoChangerModalForPackage.jsx